"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFacilityStatTiles = buildFacilityStatTiles;
exports.getActiveAlarms = getActiveAlarms;
exports.getLinkedAreaLibraryIds = getLinkedAreaLibraryIds;
/** Alarms shown on the facility page exclude resolved ones — only active/acknowledged alarms are "open". */
function getActiveAlarms(alarms) {
    return alarms.filter(function (alarm) { return alarm.status !== "RESOLVED"; });
}
/** Area-library ids already linked to the facility, so the "Add Areas" picker can exclude them. */
function getLinkedAreaLibraryIds(areas) {
    return areas.map(function (area) { var _a; return (_a = area.areaLibrary) === null || _a === void 0 ? void 0 : _a.id; }).filter(function (areaLibraryId) { return !!areaLibraryId; });
}
/** The three stat tiles at the top of the facility page: alarms, areas, managers. */
function buildFacilityStatTiles(params) {
    var activeAlarmsCount = params.activeAlarmsCount, isLoadingAlarms = params.isLoadingAlarms, isAlarmsError = params.isAlarmsError, areasCount = params.areasCount, isLoadingAreas = params.isLoadingAreas, isAreasError = params.isAreasError, managerCount = params.managerCount;
    return [
        {
            label: "Open Alarms",
            value: isLoadingAlarms || isAlarmsError ? "—" : String(activeAlarmsCount),
            icon: "solar:bell-linear",
            tone: activeAlarmsCount > 0 ? "critical" : "success",
        },
        {
            label: "Areas",
            value: isLoadingAreas || isAreasError ? "—" : String(areasCount),
            icon: "solar:widget-linear",
            tone: "info",
        },
        {
            label: "Managers",
            value: String(managerCount),
            icon: "solar:users-group-rounded-linear",
            tone: "accent",
        },
    ];
}
